import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-[70vh] md:min-h-[90vh] h-auto flex items-start overflow-hidden" data-id="element-277" data-mp="2hsgh2y09gsi3">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-278" data-mp="28tcw1ohja30y">
        <img src="https://cdn.magicpatterns.com/uploads/7LvC1K1RMTrXscUPdReLaq/BANNER_NUEVO_TAIRU..png" alt="Tratamiento facial relajante" className="w-full h-full object-cover object-center" data-id="element-279" data-mp="28w8sf8dqgjna" />
        {/* Overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-brand-charcoal/80 via-brand-charcoal/50 to-transparent h-[75%] md:h-[65%]" data-id="element-280" data-mp="2mte71wriiqu5"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-6 pb-8 md:pt-24 md:pb-0 flex flex-col items-center text-center md:items-start md:text-left" data-id="element-281" data-mp="3fiusgagpt7gv">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-3xl flex flex-col items-center md:items-start" data-id="element-282" data-mp="3kb4e3easrldc">
          <h1 className="inline-block py-2.5 px-6 md:px-8 rounded-full bg-brand-gold/25 border border-brand-gold/50 backdrop-blur-sm text-brand-gold-light font-medium uppercase tracking-[0.15em] text-[18px] sm:text-xl md:text-2xl mb-6 md:mb-8 drop-shadow" style={{
          fontSize: "14px"
        }} data-id="element-283" data-mp="2kev9p9e25z7e">
            {t('hero.title1')}
          </h1>

          <p className="text-[27px] sm:text-4xl md:text-5xl lg:text-[3.25rem] leading-snug text-white font-serif mb-5 md:mb-7 max-w-3xl text-glow-white" style={{
          fontSize: "24px"
        }} data-id="element-284" data-mp="3834qfwwezwro">
            {t('hero.tagline')}
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.25,
          ease: 'easeOut'
        }} className="flex flex-col items-center md:items-start" data-id="element-285" data-mp="1dqesn42xe3f0">
            <span aria-hidden="true" className="block h-px w-10 md:w-12 bg-brand-gold-light/80 mb-4 md:mb-5" data-id="element-286" data-mp="3iq7k00huuyu4" />
            <p className="text-[20px] sm:text-2xl md:text-[1.75rem] leading-loose text-brand-cream max-w-2xl font-light drop-shadow" style={{
            fontSize: '19px',
            fontWeight: '400'
          }} data-id="element-287" data-mp="3rsp4a9dy9heh">
              {t('hero.subtitle')}
            </p>
          </motion.div>

          <div className="flex flex-row gap-4 mt-20 sm:mt-24 md:mt-28" data-id="element-288" data-mp="aaw6d14oyzty">
            <a href="https://wa.me/15513328938?text=Hola%2C%20me%20gustar%C3%ADa%20reservar%20una%20cita" target="_blank" rel="noopener noreferrer" className="btn-gold-animated group relative overflow-hidden inline-flex justify-center items-center text-white px-9 py-4 md:px-14 md:py-5 rounded-sm font-semibold uppercase tracking-[0.2em] text-base md:text-xl transition-all duration-300 shadow-2xl shadow-brand-gold/40 ring-1 ring-brand-gold-light/50 hover:shadow-brand-gold/60 transform hover:-translate-y-1" data-id="element-289" data-mp="eec5q585beac">
              <span aria-hidden="true" className="sheen pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 skew-x-[-20deg] bg-white/25 blur-md" data-id="element-290" data-mp="2ml5ta29kkwyu" />
              <span className="relative" data-id="element-291" data-mp="2ds2gzxanuq5s">{t('hero.bookNow')}</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}